module.exports = __webpack_public_path__ + "img/Picture7.c508b621.jpg";